@if (showLoading()) {
  <div class="selection-skeleton" aria-hidden="true">
    @for (item of [1, 2, 3]; track item) {
      <div class="selection-skeleton-card">
        <ngx-skeleton-loader
          appearance="line"
          [theme]="{ height: '1.25rem', width: '60%', margin: '0 0 0.75rem' }"
          [animation]="
            themingService.theme === 'dark' ? 'progress-dark' : 'progress'
          "
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          [theme]="{ height: '0.875rem', width: '90%', margin: '0 0 0.5rem' }"
          [animation]="
            themingService.theme === 'dark' ? 'progress-dark' : 'progress'
          "
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          [theme]="{ height: '0.875rem', width: '75%', margin: '0' }"
          [animation]="
            themingService.theme === 'dark' ? 'progress-dark' : 'progress'
          "
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
} @else {
  @if (totalAgentsQuota() > 0) {
    <h6 class="mt-3">
      {{ 'company-tool.snippets.slot-selector.contingents.title' | transloco }}
    </h6>
    <div class="contingents">
      <div class="d-flex justify-content-between">
        <p>
          <b
            >{{
              'company-tool.snippets.slot-selector.contingents.total'
                | transloco
            }}:</b
          >
        </p>
        <p>
          {{ getUsedQuota(SlotType.BASIC)() ?? '-' }} /
          {{ getTotalQuota(SlotType.BASIC)() ?? '-' }}
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <p>
          <b>
            {{
              'company-tool.snippets.slot-selector.contingents.active-soucing'
                | transloco
            }}:
          </b>
        </p>
        <p>
          {{ getUsedQuota(SlotType.ACTIVE_SOURCING)() ?? '-' }} /
          {{ getTotalQuota(SlotType.ACTIVE_SOURCING)() ?? '-' }}
        </p>
      </div>
    </div>
  }

  @if (showLimitBanner()) {
    <ct-lib-info-banner type="warning">
      <div class="d-flex align-items-center">
        <p>
          {{
            'company-tool.snippets.slot-selector.banner.all-expired.text'
              | transloco
          }}
        </p>
        @if (showUpgradeSubscriptionCta()) {
          <app-button
            class="ms-auto"
            variant="white-grey"
            [iconStart]="fontawesomeService.light.arrowUp"
            (click)="onUpgradeSubscription()"
          >
            {{
              'company-tool.snippets.slot-selector.upgrade-subscription-cta'
                | transloco
            }}
          </app-button>
        }
      </div>
    </ct-lib-info-banner>
  }

  <div
    class="selection"
    [class.invalid-selection]="selectedSlotType() === null"
  >
    <ct-lib-radio-card-group
      [value]="selectedSlotType()"
      (valueChange)="pick($event)"
      orientation="horizontal"
    >
      @if (showAgentOption()) {
        <ct-lib-radio-card
          [value]="SlotType.ACTIVE_SOURCING"
          [icon]="fontawesomeService.light.sparkles"
          [label]="
            'company-tool.snippets.slot-selector.selection.active-sourcing.title'
              | transloco
          "
          [sublabel]="hasAgentSubscription() ? agentAvailableLabel() : null"
          [description]="
            'company-tool.snippets.slot-selector.selection.active-sourcing.info'
              | transloco
          "
          [disabled]="agentDisabled()"
        >
          @if (showBookAgentCta()) {
            <app-button
              radioCardFooter
              variant="white-grey"
              [fullWidth]="true"
              [loading]="bookingInProgress()"
              (click)="onBookAgent()"
            >
              {{
                'company-tool.snippets.slot-selector.selection.active-sourcing.book-cta'
                  | transloco
              }}
            </app-button>
          }
          @if (showUpgradeAgentCta()) {
            <app-button
              radioCardFooter
              variant="white-grey"
              [fullWidth]="true"
              [loading]="bookingInProgress()"
              (click)="onBookAgent()"
            >
              {{
                'company-tool.snippets.slot-selector.selection.active-sourcing.upgrade-cta'
                  | transloco
              }}
            </app-button>
          }
        </ct-lib-radio-card>
      }

      <ct-lib-radio-card
        [value]="SlotType.BASIC"
        [icon]="fontawesomeService.light.list"
        [label]="
          'company-tool.snippets.slot-selector.selection.basic.title'
            | transloco
        "
        [sublabel]="basicAvailableLabel()"
        [description]="
          'company-tool.snippets.slot-selector.selection.basic.info' | transloco
        "
        [disabled]="getQuotaExpired(SlotType.BASIC)() && subscribed()"
      />

      <ct-lib-radio-card
        [value]="SlotType.NOT_LISTED"
        [icon]="fontawesomeService.light.eyeSlash"
        [label]="
          'company-tool.snippets.slot-selector.selection.not-listed.title'
            | transloco
        "
        [description]="
          'company-tool.snippets.slot-selector.selection.not-listed.info'
            | transloco
        "
      />
    </ct-lib-radio-card-group>
  </div>

  <div class="invalid">
    <p>
      {{
        'company-tool.snippets.slot-selector.validation.no-selection'
          | transloco
      }}
    </p>
  </div>
}

<app-agents-booking-modal
  #agentsBookingModal
  (agentsBooked)="onAgentBooked()"
></app-agents-booking-modal>

<app-base-booking-modal
  #baseBookingModal
  (planChanged)="onBasePlanChanged()"
></app-base-booking-modal>
